import { Stack, Typography, Grid, MenuItem, Box } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 16px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledDataTitle = styled(Typography)`
  margin-bottom: 8px !important;
  width: 100%;
  color: ${theme.palette.primary.main};
`;

export const StyledMessageStatusTitle = styled(Typography)`
  margin-bottom: 24px !important;
  padding-bottom: 15px;
  margin-top: 40px !important;
  width: 100%;
  border-bottom: 2px solid ${theme.palette.primary.main};
`;

export const StyledDataText = styled(Box)`
  color: ${theme.palette.secondary.dark};
  font-size: 16px !important;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
`;

export const StyledMenuItem = styled(MenuItem)`
  text-align: right !important;
  direction: rtl;
`;

export const StyledGridIcons = styled(Grid)`
  display: flex;
  justify-content: left;
  align-items: center;
  & button {
    box-shadow: -2px -2px 15px #dbdbdb, 2px 2px 15px #cacaca;
    margin: 0px 8px;
    padding: 5px;
    & svg {
      border: none !important;
      border-radius: 100%;
      box-shadow: none !important;
      @media (max-width: 700px) {
        font-size: 24px;
      }
    }
    @media (max-width: 700px) {
      margin: 0px 5px;
    }
    @media (max-width: 599px) {
      margin: 10px 8px 0px;
    }
  }
  & :hover {
    box-shadow: inset -2px -2px 5px #dbdbdb, inset 2px 2px 5px #cacaca;
    & button {
      & svg {
        box-shadow: none;
      }
    }
  }
`;

export const StyledTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: gray;
`;

export const StyledGrid = styled(Grid)`
  margin-bottom: 24px !important;
`;
